import { render, staticRenderFns } from "./serviceMall.vue?vue&type=template&id=2590f330&scoped=true&"
import script from "./serviceMall.vue?vue&type=script&lang=js&"
export * from "./serviceMall.vue?vue&type=script&lang=js&"
import style0 from "./serviceMall.vue?vue&type=style&index=0&id=2590f330&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2590f330",
  null
  
)

export default component.exports